module.exports = __webpack_public_path__ + "static/wrong-banana_2008-76808f6633ea93cf0e36f05b6b2dbe0a.jpg";